import { useState } from 'react';
import { API_URL } from '@constants';
import { paths } from '../../types/api';
import { ApiError, useApiConfig } from '@hooks/useApiConfig';

const ENDPOINT_URL = '/cfg-system-settings/banner_info';

export type GetBannerInfoSuccessResponse =
    paths['string']['get']['responses']['200']['content']['application/json'];

/**
 * Requests endpoint to get banner info.
 */
export const useGetBannerInfo = () => {
    const { getHeaders, handleCommonErrors } = useApiConfig();

    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<string | null>(null);
    const [lastResponseTime, setLastResponseTime] = useState<Date | null>(null);
    const [data, setData] = useState<GetBannerInfoSuccessResponse | null>(null);

    const request = async () => {
        setLoading(true);
        setError(null);

        try {
            const response = await fetch(`${API_URL}${ENDPOINT_URL}`, {
                method: 'GET',
                headers: getHeaders(),
            });

            if (!response.ok) {
                const json = await response.json();
                const error = new Error(json.message || '') as ApiError;
                error.statusCode = response.status;
                error.errors = json.errors;
                throw error;
            }

            const json: GetBannerInfoSuccessResponse = await response.json();
            setData(json.data);
        } catch (err: any) {
            handleCommonErrors(err);
            err.message && setError(err.message);
        } finally {
            setLoading(false);
            setLastResponseTime(new Date());
        }
    };

    return { request, data, loading, error, lastResponseTime };
};